import React from 'react'

const Calculators = () => {
  return (
    <div className='mx-auto p-4'>
      Calculators
    </div>
  )
}

export default Calculators
